export default __webpack_public_path__ + "static/media/whatsapp.12e03f0f.svg";